module.exports = new __parcel__URL__("mtbs-burn-severity--dataset-cover.13ecbe43.jpg").toString();